export {
  default as brush,
  brushX,
  brushY,
  brushSelection
} from "./src/brush";



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-brush/index.js
// module id = ../../../../d3-brush/index.js
// module chunks = 3